var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3182 13.25H7.57275C6.6 13.25 5.7375 12.6118 5.47425 11.6975L3.19425 3.97175C3.11325 3.692 2.844 3.5 2.5365 3.5H0.75C0.33525 3.5 0 3.164 0 2.75C0 2.336 0.33525 2 0.75 2H2.5365C3.50925 2 4.371 2.63825 4.63425 3.5525L5.061 5H16.5322C17.0002 5 17.4443 5.22275 17.7195 5.59625C17.9925 5.96675 18.0712 6.43025 17.9355 6.86825L16.3883 11.7792C16.0852 12.6657 15.255 13.25 14.3182 13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17C7.42275 17 6.75 16.3273 6.75 15.5C6.75 14.6727 7.42275 14 8.25 14C9.07725 14 9.75 14.6727 9.75 15.5C9.75 16.3273 9.07725 17 8.25 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17C12.6727 17 12 16.3273 12 15.5C12 14.6727 12.6727 14 13.5 14C14.3273 14 15 14.6727 15 15.5C15 16.3273 14.3273 17 13.5 17Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4ee4a342dfd2256eb7a01ed9a2798a10.svg";
export { ForwardRef as ReactComponent };